<template>
  <BContainer :title="$t('title.reportCompanyScoreCompare')">
    <CompanyFilter @apply="getScores">
      <!-- <template v-slot:customButtons>
        <DownloadExcel
          v-if="isExportButtonActive"
          :data="tableData"
          :fields="excelFields"
          :name="`${title}.xls`"
        >
          <button class="button is-link">{{ $t('button.export') }}</button>
        </DownloadExcel>
      </template>-->
    </CompanyFilter>
    <section
      class="section b-portlet has-background-light"
      v-if="tableData && tableData.length > 0"
    >
      <b-table
        :data="tableData"
        :bordered="true"
        :striped="true"
        :hoverable="true"
        :mobile-cards="true"
        v-if="tableData.length > 0"
      >
        <template slot-scope="props">
          <b-table-column field="no" label="No" width="40" numeric>
            {{ props.row.no }}
          </b-table-column>
          <b-table-column field="name" :label="$t('title.question')">{{
            props.row.name
          }}</b-table-column>
          <b-table-column
            v-for="user in users"
            :key="user.id"
            :field="user.id"
            :label="user.company.name"
          >
            <b-tag :type="props.row[user.id] === $t('button.yes') ? 'is-success' : 'is-danger'">{{
              props.row[user.id]
            }}</b-tag>
          </b-table-column>
        </template>
      </b-table>
    </section>
    <section
      v-if="chartData"
      class="section has-background-light"
      style="padding-top:15px; margin-top:15px;"
    >
      <div class="column is-size-4 has-text-centered">{{ $t('title.netaScore') }}</div>
      <div class="columns is-centered">
        <div class="column is-3-fullhd is-7-tablet">
          <BarChart
            :name="'final'"
            :data="chartData.final"
            :title="$t('title.final')"
            :labels="chartLabels"
          ></BarChart>
        </div>
      </div>
      <div class="column is-size-4 has-text-centered">
        {{ $t('title.internalControlQualificationLevels') }}
      </div>
      <div class="columns is-centered is-multiline">
        <div class="column is-3-fullhd is-7-tablet">
          <BarChart
            :name="'financialReport'"
            :data="chartData.financialReport"
            :title="$t('title.financialReport')"
            :labels="chartLabels"
          ></BarChart>
        </div>
        <div class="column is-3-fullhd is-7-tablet">
          <BarChart
            :name="'adaptation'"
            :data="chartData.adaptation"
            :title="$t('title.adaptation')"
            :labels="chartLabels"
          ></BarChart>
        </div>
        <div class="column is-3-fullhd is-7-tablet">
          <BarChart
            :name="'operation'"
            :data="chartData.operation"
            :title="$t('title.operation')"
            :labels="chartLabels"
          ></BarChart>
        </div>
        <div class="column is-3-fullhd is-7-tablet">
          <BarChart
            :name="'abuse'"
            :data="chartData.abuse"
            :title="$t('title.abuse')"
            :labels="chartLabels"
          ></BarChart>
        </div>
      </div>
      <div class="column is-size-4 has-text-centered">
        {{ $t('title.internalControlComponentQualificationLevels') }}
      </div>
      <div class="columns is-centered is-multiline">
        <div class="column is-3-fullhd is-7-tablet" v-if="chartData.controlEnvironment != null">
          <BarChart
            :name="'controlEnvironment'"
            :data="chartData.controlEnvironment"
            :title="$t('title.controlEnvironment')"
            :labels="chartLabels"
          ></BarChart>
        </div>
        <div class="column is-3-fullhd is-7-tablet" v-if="chartData.riskAssessment != null">
          <BarChart
            :name="'riskAssessment'"
            :data="chartData.riskAssessment"
            :title="$t('title.riskAssessment')"
            :labels="chartLabels"
          ></BarChart>
        </div>
        <div class="column is-3-fullhd is-7-tablet" v-if="chartData.controlActivities != null">
          <BarChart
            :name="'controlActivities'"
            :data="chartData.controlActivities"
            :title="$t('title.controlActivities')"
            :labels="chartLabels"
          ></BarChart>
        </div>
        <div
          class="column is-3-fullhd is-7-tablet"
          v-if="chartData.informationCommunication != null"
        >
          <BarChart
            :name="'informationCommunication'"
            :data="chartData.informationCommunication"
            :title="$t('title.informationCommunication')"
            :labels="chartLabels"
          ></BarChart>
        </div>
      </div>
      <div class="columns is-centered">
        <div class="column is-3-fullhd is-7-tablet" v-if="chartData.monitoring != null">
          <BarChart
            :name="'monitoring'"
            :data="chartData.monitoring"
            :title="$t('title.monitoring')"
            :labels="chartLabels"
          ></BarChart>
        </div>
      </div>
    </section>
  </BContainer>
</template>
<script>
import ApiService from '../../_api/api.service'
import CompanyFilter from './CompanyFilter.vue'
import { BarChart } from '../../components'

export default {
  components: { CompanyFilter, BarChart },
  data() {
    return {
      tableData: null,
      chartData: null,
      chartLabels: [],
      title: 'report-data',
      excelFields: {},
      excelData: [],
      isExportButtonActive: false,
      users: []
    }
  },
  mounted() {
    this.excelFields = this.getExcelFields()
  },
  methods: {
    getScores(filter) {
      const { processId, users } = filter
      this.users = users
      const userIds = users.map(cu => cu.id)
      this.chartData = null
      this.tableData = null
      // this.title = filter.content.title;
      ApiService.post('/user/scores', { processId, userIds }).then(data => {
        this.isExportButtonActive = true
        if (userIds.length > 5) {
          this.generateTableData(data)
        } else {
          this.loadChartData(data)
        }
      })
    },
    generateTableData(apiData) {
      const tableData = []
      const scoreKeys = [
        'final',
        'financialReport',
        'adaptation',
        'operation',
        'abuse',
        'controlEnvironment',
        'riskAssessment',
        'controlActivities',
        'informationCommunication',
        'monitoring'
      ]

      scoreKeys.forEach(key => {
        const row = { name: this.$t(`title.${key}`) }
        apiData.forEach(score => {
          const companyName = this.users.filter(u => u.id === score.userId)[0].company.name
          row[companyName] = score[key]
        })
        tableData.push(row)
      })
      this.tableData = tableData
    },
    loadChartData(data) {
      this.chartLabels = []
      if (data && data.length > 0) {
        this.chartData = {
          final: [],
          financialReport: [],
          adaptation: [],
          operation: [],
          abuse: [],
          controlEnvironment: [],
          riskAssessment: [],
          controlActivities: [],
          informationCommunication: [],
          monitoring: []
        }
        data.forEach(score => {
          const label = this.users.filter(u => u.id === score.userId)[0].company.name
          this.chartLabels.push(label)
          this.chartData.final.push(score.finalScore / 100)
          this.chartData.financialReport.push(score.financialReportFinal)
          this.chartData.adaptation.push(score.adaptationFinal)
          this.chartData.operation.push(score.operationFinal)
          this.chartData.abuse.push(score.abuseFinal)
          this.chartData.controlEnvironment.push(score.controlEnvironmentScore)
          this.chartData.riskAssessment.push(score.riskAssessmentScore)
          this.chartData.controlActivities.push(score.controlActivitiesScore)
          this.chartData.informationCommunication.push(score.informationCommunicationScore)
          this.chartData.monitoring.push(score.monitoringScore)
        })
      }
    },
    getExcelFields() {
      const fields = {}
      fields[this.$t('validation.attributes.no')] = 'no'
      fields[this.$t('validation.attributes.question')] = 'name'
      return fields
    }
  }
}
</script>
